/**
 * Don't use these functions. They do not update on browser resize or media query change.
 */
//updated the default because 768px is the breakpoint we're using for mobile site wise
export function isMobileWidth(breakpoint = 768): boolean {
    return window.innerWidth < breakpoint;
}
export function screenSize(): number {
    return window.innerWidth;
}
